import { __assign } from "tslib";
import { fetchWithToken, getRegion } from "@adsk/acs-sc-web-platform-api";
export default (function (url, fetchData) {
    var mergedFetchData = __assign(__assign({}, fetchData), { headers: __assign(__assign({}, (fetchData && fetchData.headers)), { "x-ads-region": getRegion() }) });
    return fetchWithToken(url, mergedFetchData);
});
